import React from 'react'
import './FabContact.css'

function FabContact() {
  return (
    <div className="fab_contact_container">
      <h1>League Contact</h1>
      <section>
      <h3>Steve | League Commissioner</h3>
      <a href="mailto:fabcommisioner@gmail.com">fabcommisioner@gmail.com</a>
      <h3>Text Message Number</h3>
      <p>949-209-FA60</p>
      </section>
      {/* <form>
        <h3>PLEASE COMPLETE THE FORM BELOW</h3>

        <label>Name (required)</label>
        <div className="name_wrapper">
          <div>
            <label>First Name</label>
            <input type="text" />
          </div>
          <div>
            <label>Last Name</label>
            <input type="text" />
          </div>
        </div>

        <label>
          Email Address (required)
          <input type="email" />
        </label>

        <label>
          Subject (required)
          <input type="text" />
        </label>

        <label>
          Message (required)
          <textarea />
        </label>

        <button className="contact-submit-btn" type="submit">SUBMIT</button>
      </form> */}

    </div>
  )
}

export default FabContact
